module.exports = __webpack_public_path__ + "img/18.7329b3de.jpg";